export default class ClubEmployeeKnowledge {
    constructor() {
        this.id = null;

        this.hasCertificateOfGoodConduct = false;
        this.certificateOfGoodConductDelivered = null;
        this.certificateOfGoodConductValidUntil = null;

        this.hasFireProtectionPlan = false;
        this.fireProtectionPlanDoneAt = null;
        this.fireProtectionPlanValidUntil = null;

        this.hasFirstAidCertificate = false;
        this.firstAidCertificatePresentedAt = null;
        this.firstAidCertificateValidUntil = null;

        this.hasHealthCertificate = false;
        this.healthCertificateDelivered = null;
        this.healthCertificateValidUntil = null;

        this.hasHygienePlan = false;
        this.hygienePlanDoneAt = null;
        this.hygienePlanValidUntil = null;

        this.miscellaneousSkills = null;
    }

    static fromData(data) {
        if (!data) {
            return;
        }

        const knowledge = new ClubEmployeeKnowledge();

        if (!data.id) {
            return knowledge;
        }

        knowledge.id = data.id;

        knowledge.hasCertificateOfGoodConduct = data.hasCertificateOfGoodConduct;
        knowledge.certificateOfGoodConductDelivered = data.certificateOfGoodConductDelivered;
        knowledge.certificateOfGoodConductValidUntil = data.certificateOfGoodConductValidUntil;

        knowledge.hasFireProtectionPlan = data.hasFireProtectionPlan;
        knowledge.fireProtectionPlanDoneAt = data.fireProtectionPlanDoneAt;
        knowledge.fireProtectionPlanValidUntil = data.fireProtectionPlanValidUntil;

        knowledge.hasFirstAidCertificate = data.hasFirstAidCertificate;
        knowledge.firstAidCertificatePresentedAt = data.firstAidCertificatePresentedAt;
        knowledge.firstAidCertificateValidUntil = data.firstAidCertificateValidUntil;

        knowledge.hasHealthCertificate = data.hasHealthCertificate;
        knowledge.healthCertificateDelivered = data.healthCertificateDelivered;
        knowledge.healthCertificateValidUntil = data.healthCertificateValidUntil;

        knowledge.hasHygienePlan = data.hasHygienePlan;
        knowledge.hygienePlanDoneAt = data.hygienePlanDoneAt;
        knowledge.hygienePlanValidUntil = data.hygienePlanValidUntil;

        knowledge.miscellaneousSkills = data.miscellaneousSkills;

        return knowledge;
    }

    serialize() {
        return {
            employeeKnowledgeId: this.id,
            hasCertificateOfGoodConduct: this.hasCertificateOfGoodConduct,
            certificateOfGoodConductDelivered: this.certificateOfGoodConductDelivered,
            certificateOfGoodConductValidUntil: this.certificateOfGoodConductValidUntil,
            hasFireProtectionPlan: this.hasFireProtectionPlan,
            fireProtectionPlanDoneAt: this.fireProtectionPlanDoneAt,
            fireProtectionPlanValidUntil: this.fireProtectionPlanValidUntil,
            hasFirstAidCertificate: this.hasFirstAidCertificate,
            firstAidCertificatePresentedAt: this.firstAidCertificatePresentedAt,
            firstAidCertificateValidUntil: this.firstAidCertificateValidUntil,
            hasHealthCertificate: this.hasHealthCertificate,
            healthCertificateDelivered: this.healthCertificateDelivered,
            healthCertificateValidUntil: this.healthCertificateValidUntil,
            hasHygienePlan: this.hasHygienePlan,
            hygienePlanDoneAt: this.hygienePlanDoneAt,
            hygienePlanValidUntil: this.hygienePlanValidUntil,
            miscellaneousSkills: this.miscellaneousSkills,
        };
    }
}
